import React from 'react';
import { Reveal } from './Reveal';
import { transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section aria-labelledby="transformation-title" className="bg-brand-cream px-4 py-20 md:py-28" data-id="element-196" data-mp="31xicmqebhih6">
      <Reveal className="mx-auto max-w-content" data-id="element-197" data-mp="2wzqirqu43mac">
        <div className="mx-auto max-w-3xl text-center" data-id="element-198" data-mp="2rzc9y6kos8b9">
          <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-199" data-mp="2s0x43v339p8l">
            LA TUA TRASFORMAZIONE IN PALESTRA
          </p>
          <h2 id="transformation-title" className="text-3xl font-extrabold leading-[1.08] tracking-tight text-brand-primary md:text-5xl" data-id="element-200" data-mp="2j57l1sp456yd">
            Da Insegnante che Improvvisa a{' '}
            <span className="italic text-brand-accent" data-id="element-201" data-mp="299w89fx9m9t9">Guida Sicura del Movimento.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-202" data-mp="2486rrkr9x3xs">
            <strong className="font-bold text-brand-text" data-id="element-203" data-mp="209hk88sx2gm2">EDUCAZIONE FISICA PRONTA™</strong> trasforma{' '}
            <strong className="font-bold text-brand-text" data-id="element-204" data-mp="f8zmo3czn1zy">ogni lezione di motoria</strong> — anche se non hai una
            formazione sportiva specifica — con{' '}
            <strong className="font-bold text-brand-text" data-id="element-205" data-mp="5e7kem8gnqyu">materiali pronti, corretti e strutturati</strong>.
          </p>
        </div>
        <div className="mx-auto mt-12 grid max-w-3xl gap-4 md:grid-cols-3" data-id="element-206" data-mp="a9mxvd2k3kuq">
          {transformationStats.map(({
          value,
          label
        }) => <div key={value} className="rounded-[18px] border border-brand-sand bg-brand-alt px-5 py-7 text-center shadow-sm" data-id="element-207" data-mp="1316jf3mmlazw">
              <strong className="block font-display text-3xl font-extrabold leading-none text-brand-accent" data-id="element-208" data-mp="p38cukejqiuy">
                {value}
              </strong>
              <span className="mt-3 block text-[12px] font-semibold leading-snug text-brand-gray" data-id="element-209" data-mp="39qbjcvkjbl4d">{label}</span>
            </div>)}
        </div>
      </Reveal>
    </section>;
}